import { useState } from 'react';

/**
 * Interface for the useDisclosure hook return value
 */
export interface UseDisclosureInterface {
  /** Current open state */
  isOpen: boolean;
  /** Function to close the disclosure */
  onClose: () => void;
  /** Function to open the disclosure */
  onOpen: () => void;
  /** Function to toggle the disclosure state */
  onToggle: () => void;
}

/**
 * A custom hook for managing disclosure state (open/closed)
 *
 * @returns {UseDisclosureInterface} An object containing the current state and functions to manipulate it
 */
const useDisclosure = (): UseDisclosureInterface => {
  const [isOpen, setIsOpen] = useState(false);

  /**
   * Toggles the disclosure state
   */
  const onToggle = () => {
    setIsOpen(!isOpen);
  };

  /**
   * Opens the disclosure
   */
  const onOpen = () => {
    setIsOpen(true);
  };

  /**
   * Closes the disclosure
   */
  const onClose = () => {
    setIsOpen(false);
  };

  return { isOpen, onToggle, onOpen, onClose };
};

export default useDisclosure;
